import List from '../../containers/SalaryHistories/List';
import Edit from '../../containers/SalaryHistories/Edit';
import Create from '../../containers/SalaryHistories/Create';
import Show from '../../containers/SalaryHistories/Show';

export default { List, Edit, Create, Show };
